/**
 * @generated SignedSource<<f3da61e4c6fc7728a1e50b09df883cc5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type richTextFullIssue$data = {
  readonly canBeExported?: boolean | null | undefined;
  readonly canDownloadAttachment?: boolean | null | undefined;
  readonly " $fragmentType": "richTextFullIssue";
};
export type richTextFullIssue$key = {
  readonly " $data"?: richTextFullIssue$data;
  readonly " $fragmentSpreads": FragmentRefs<"richTextFullIssue">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblockattachmentdownloadsegregationrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "richTextFullIssue",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblockattachmentdownloadsegregationrelayprovider",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "canBeExported"
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblockattachmentdownloadsegregationrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "canDownloadAttachment"
        }
      ]
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "73fe6fd89a13cfc0edc1c2128237e8ff";

export default node;
